import BreakdownSectionTable from 'features/dashboard/components/BreakdownSectionTable';
import { formatArea, formatNumeric } from 'utils/format';

const WeightedSpaceBreakdownSectionTable = ({ breakdown, measurementSystem, withTotalSpaces = false }) => {
  const rows = [
    withTotalSpaces
      ? {
          key: 'quantity',
          title: 'Total Spaces',
          format: formatNumeric
        }
      : null,
    {
      key: 'totalCapacity',
      title: 'Total Capacity',
      format: formatNumeric
    },
    {
      key: 'weightedCapacity',
      title: 'Weighted Capacity',
      format: formatNumeric
    },
    {
      key: 'area',
      title: 'Area',
      format: (value) => formatArea(value, measurementSystem)
    }
  ].filter(Boolean);

  return (
    <BreakdownSectionTable
      headers={[
        {
          key: 'name',
          title: ''
        },
        {
          key: 'enclosed',
          title: 'Enclosed'
        },
        {
          key: 'open',
          title: 'Open'
        }
      ]}
      rows={rows.map(({ key, title, format }) => ({
        name: title,
        enclosed: format(breakdown?.enclosed[key]),
        open: format(breakdown?.open[key])
      }))}
    />
  );
};

export default WeightedSpaceBreakdownSectionTable;
